/**
 * @author  Joshua Ruesweg
 * @copyright  2001-2021 WoltLab GmbH
 * @license  GNU Lesser General Public License <http://opensource.org/licenses/lgpl-license.php>
 * @deprecated Use the Module WoltLabSuite/Core/Ui/Object/Action/Toggle instead.
 */
define('WoltLabSuite/Core/Ui/Object/Action/Toogle',["require", "exports", "./Toggle"], function (require, exports, Toggle_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.setup = void 0;
    Object.defineProperty(exports, "setup", { enumerable: true, get: function () { return Toggle_1.setup; } });
});

